export interface POSIntegration {
  name: string
  clientId: string
  config?: Partial<POSIntegrationConfig>
}

export interface POSIntegrationConfig extends POSCBSNorthStarIntegrationConfig {
  baseUrl: string
  authUrl: string
  username: string
  password: string
  orgShortName: string
  locRef: string
  rvcRef: string
  displayName: string
  displayPriceName: string
  url: string
  token: string
  url_clover: string
  token_clover: string
  focus_login: string
  focus_password: string
  focus_restaurant: string
}

export interface POSCBSNorthStarIntegrationConfig {
  access_key: string
  base_url: string
  site_id: string
}

export enum POSName {
  TableNeeds = "TableNeeds",
  Oracle = "Oracle",
  CBSNorthStar = "CBSNorthStar",
  Clover = "Clover",
  Focus= "Focus"
}

// POS Popup types

export type DefaultFields = {
  posName: string,
  clientId: string,
}

export type POSField =
  | "authUrl"
  | "baseUrl"
  | "username"
  | "password"
  | "orgShortName"
  | "locRef"
  | "rvcRef"
  | "url"
  | "token"
  | "displayName"
  | "displayPriceName"
  | "access_key"
  | "site_id"
  | "base_url"
  | "url_clover"
  | "token_clover"
  | "focus_login"
  | "focus_password"
  | "focus_restaurant";

export type POSInfoFields = {
  Oracle: DefaultFields & Partial<Record<POSField, string>>;
  TableNeeds: DefaultFields & Partial<Record<POSField, string>>;
  CBSNorthStar: DefaultFields & Partial<Record<POSField, string>>;
  Clover: DefaultFields & Partial<Record<POSField, string>>;
  Focus: DefaultFields & Partial<Record<POSField, string>>;
};

export type POSAction = "CREATE" | "UPDATE" | "REFRESH"

export type POSPageContext = "ocbs" | "menus"
